import { AlertTriangle } from 'lucide-react'
import { cn, Popover, PopoverContent, PopoverTrigger } from '@teach/ui'
import { useDesignOverflow } from '@/features/editor/lib/designOverflow'
import { useMessages } from '@/i18n'
import { messages } from './messages'
import { useHoverPopover } from '../shared/useHoverPopover'

/**
 * Значок «текста много» (жёлтый) / «блок переполнен» (красный) рядом с инструментами холста; пояснение — во всплывашке.
 * Открывается и наведением мыши, и нажатием: тултип по одному наведению на телефоне
 * не открывался, и текст предупреждения был недоступен. И фокусом с клавиатуры; клик
 * мышью открытую подсказку не закрывает (`useHoverPopover`). Уже `lg` рядом со значком
 * стоит короткая подпись — один значок там читался как сломанная кнопка.
 */
export const DesignOverflowWarning = () => {
  const m = useMessages(messages)
  const level = useDesignOverflow()
  const { open, setOpen, triggerProps } = useHoverPopover()
  if (level === 'fits') return null
  const over = level === 'over'
  const label = over ? m.overflowLabel : m.overflowWarnLabel
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          aria-label={label}
          {...triggerProps}
          className={cn(
            'flex h-8 items-center gap-1.5 rounded-full border bg-background/60 px-2.5 text-xs font-medium backdrop-blur-xl',
            'lg:size-8 lg:justify-center lg:border-0 lg:bg-transparent lg:px-0 lg:backdrop-blur-none',
            over ? 'border-destructive/30 text-destructive' : 'border-warning/30 text-warning',
          )}
        >
          <AlertTriangle className="size-4 shrink-0 lg:size-5" />
          <span className="lg:hidden">{label}</span>
        </button>
      </PopoverTrigger>
      <PopoverContent
        className="w-auto max-w-[260px] rounded-xl bg-foreground px-3 py-1.5 text-sm leading-snug text-background"
        onOpenAutoFocus={(e) => e.preventDefault()}
      >
        {over ? m.overflowHint : m.overflowWarnHint}
      </PopoverContent>
    </Popover>
  )
}
